module.exports = __webpack_public_path__ + "static/media/recoverPasswordDialogImage.1731dcc1.png";